import { GTVehicleStatus } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const vehicleStatusMessages = defineMessages({
  [GTVehicleStatus.Active]: {
    id: 'vehicles.status.active',
    defaultMessage: 'Active'
  },
  [GTVehicleStatus.Inactive]: {
    id: 'vehicles.status.inactive',
    defaultMessage: 'Inactive'
  },
  [GTVehicleStatus.OutOfService]: {
    id: 'vehicles.status.outOfService',
    defaultMessage: 'Out of service'
  }
})
